import { FC } from 'react';
import { AddInput } from '../../../../../../lib/components/AddInput';
import { ListFooter } from '../../../../../../lib/components/List/ListFooter';
import { usePartnerConfigForm } from '../../../hooks/usePartnerConfigForm';

interface IProps {
	on_ip_added: (ip: string) => void;
}

export const AddIpInput: FC<IProps> = ({ on_ip_added }) => {
	const { validators } = usePartnerConfigForm();

	return (
		<ListFooter>
			<AddInput
				{...{
					on_added: on_ip_added,
					validate: validators.valid_ip,
					format_value: (ip) => ip.replace(/ /g, '.').replace(/[^0-9.]/g, ''),
				}}
			/>
		</ListFooter>
	);
};
